export default {
    GPS: {
        DocumentObjectId: "ET11",
        attributes: {
            Points: "PT67",
            Name: "PT1362"
        }
    },
    coordinate: {
        DocumentObjectId: "socrat.coordinate",
        attributes: {
            latitude: "PT10024",
            longitude: "PT10025",
            geotag: "PT10026"
        },
        methods: { addOnGraph: { Id: "geo_empty", Name: "geo_empty" } }
    },
    PHOTO: { DocumentObjectId: "ET87", attributes: { URL: "PT955" } },
    PHRASE: { DocumentObjectId: "ET68", attributes: { Phrase: "PT503" } }
};
